@if (title) {
  <ng-container header>{{title}}</ng-container>
}
<form [formGroup]="form">
  <rask-selector
    label="{{'LEVERANTORSORDER_DETAIL_ROW_HANDELSSORTIMENTSGRUPP' | translate}}"
    aid="inputHandelssortimentgrupp"
    formControlName="handelssortimentsgrupp"
    [rule]="validation.handelssortimentgrupp"
    [required]="true"
    [reverseLookup]="false"
    [ngClass]="getClass(3,6)"
    [values]="handelssortimentGrupper"
    [viewFormatter]="handelssortimentgruppViewFormatter"
    [raskDisabledControl]="isCopy">
  </rask-selector>
  <rask-input-number
    label="{{'LEVERANTORSORDER_DETAIL_ROW_KVANTITET' | translate}}"
    aid="inputKvantitet"
    [ngClass]="getClass(1,4)"
    [required]="true"
    [rule]="validation.kvantitet"
    formControlName="kvantitet"
    [raskDisabledControl]="isCopy">
  </rask-input-number>
  <rask-selector
    [required]="true"
    label="{{'LEVERANTORSORDER_DETAIL_ROW_MATTSLAG' | translate}}"
    aid="inputMattslag"
    style="width:120px;max-width:none;"
    formControlName="mattslag"
    [ngClass]="getClass(2)"
    [rule]="validation.mattslag"
    [values]="mattslag"
    [formatter]="mattslagFormatter"
    [viewFormatter]="mattslagFormatter"
    [raskDisabledControl]="isCopy">
  </rask-selector>
  <rask-datepicker
    aid="inputPeriodFrom"
    style="width:160px;max-width:none;"
    [required]="true"
    label="{{'DEFAULT_PERIODFROM' | translate}}"
    [rule]="validation.periodFrom"
    formControlName="periodFrom"
    [ngClass]="getClass(1,2)"
    [minDate]=""
    [raskDisabledControl]="isCopy">
  </rask-datepicker>
  <rask-datepicker
    label="{{'DEFAULT_PERIODTOM' | translate}}"
    aid="inputPeriodTom"
    style="width:160px;max-width:none;"
    [required]="true"
    [rule]="validation.periodTom"
    formControlName="periodTom"
    [minDate]="model.periodFrom"
    [ngClass]="getClass(1,2)"
    [raskDisabledControl]="isCopy">
  </rask-datepicker>
  <rask-checkbox
    aid="egenBefraktning"
    [ngClass]="getClass(1)"
    label="{{'LEVERANTORSORDER_EGEN_BEFRAKTNING' | translate}}"
    formControlName="egenBefraktning"
    [raskDisabledControl]="isCopy">
  </rask-checkbox>
  @if (!isNew) {
    <rask-input
      aid="balansInformation"
      class="col-lg-1 low"
      [ngClass]="{'negative': balans < 0}"
      [value]="balans | number"
      [readonly]="true"
      [disabled]="isCopy">
    </rask-input>
  }
  @if (isCopy) {
    <rask-checkbox [ngClass]="getClass(1)" text="Kopiera med" formControlName="kopiera"></rask-checkbox>
  }
  @if (!isNew && !isCopy) {
    <div class="buttons col-lg-1">
      <div class="row">
        <div class="col-lg-6">
          @if (!isNew) {
            <rask-button
              aid="buttonLrUppdatera"
              color="secondary"
              [disabled]="!updateLevraderAvailable"
              icon="fas fa-sync-alt"
              (click)="updateLeveransrader()">
            </rask-button>
          }
        </div>
        <div class="col-lg-6">
          @if (!isNew) {
            <rask-button
              aid="buttonLrTabort"
              color="tertiary"
              icon="far fa-trash-alt"
              (click)="delete()"
              [disabled]="order.leverantorsorderrader.length === 1  || !canEdit()"
              negative>
            </rask-button>
          }
        </div>
      </div>
    </div>
  }
</form>
